/**
 * @prettier
 * @flow
 */
import { KEY_NAME } from 'src/utils/localstorage/getApphookInLocaleStorage';

export function setApphookInLocaleStorage(value: string): void {
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value ?? ''));
}
